export default "__VITE_ASSET__BhodxYmi__"